
<div>
  <app-nav-bar>
    <main class="container-main">
      <div class="row">

        
        <div class="col-md-12">
          <mat-card class="card-content">
            <mat-card-content>
              <router-outlet></router-outlet>
            </mat-card-content>
          </mat-card>
        </div>
        
    
      </div>
    </main>
  </app-nav-bar>
 
</div>
